import { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { ISelectOptions } from "../../../types/inputs";
import { useContextSite } from "../../../context/Context";
import { MesesDoAnoEnum } from "../../../enums/mesesEnum";
import {
  IPesquisaProps,
  IPesquisaSatisfacaoPrincipalDTO,
} from "../../../types/pesquisa";
import { Pesquisa } from "../../../services/Pesquisa";

const mothOptions: ISelectOptions[] = Object.entries(MesesDoAnoEnum)
  .filter((i) => !isNaN(parseInt(i[0])))
  .map((v) => ({
    value: v[0],
    label: v[1] as string,
  }));

const empresaOptions = [
  {
    label: "Log",
    value: "Log",
  },
  {
    label: "Starcheck",
    value: "Starcheck",
  },
  {
    label: "Tokyo",
    value: "Tokyo",
  },
  {
    label: "Velox",
    value: "Velox",
  },
];
export const useCustomerSatisfaction = () => {
  const empresa = process.env.REACT_APP_PROJECT;
  const { setIsLoad } = useContextSite();
  const currentYear = new Date().getFullYear();
  const currentMoth = new Date().getMonth() + 1;
  const yearOptions = Array.from({ length: currentYear - 2019 }, (_, index) => {
    const year = 2020 + index;
    return { value: year, label: year.toString() };
  });
  const [filter, setFilter] = useState<IPesquisaProps>({
    ano: currentYear,
    mes: currentMoth,
    empresa,
    unidade: "",
  });
  // Filtro da última busca, para o subtítulo não mudar antes de aplicar
  const [appliedFilter, setAppliedFilter] = useState(filter);
  const [pesquisa, setPesquisa] = useState<IPesquisaSatisfacaoPrincipalDTO[]>(
    [] as IPesquisaSatisfacaoPrincipalDTO[]
  );

  function getPesquisa() {
    setIsLoad(true);
    Pesquisa.resultadoPesquisa(filter)
      .then(({ data }) => {
        setPesquisa(data);
        setAppliedFilter(filter);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    getPesquisa();
  }, []);

  function handleFilter(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    getPesquisa();
  }

  return {
    yearOptions,
    mothOptions,
    filter,
    appliedFilter,
    setFilter,
    handleFilter,
    pesquisa,
    empresaOptions,
  };
};
